import { alpha, Components, Theme } from '@mui/material/styles';
import { borderRadius } from '../foundations/shape';

export const MuiChip: Components<Theme>['MuiChip'] = {
  styleOverrides: {
    root: {
      borderRadius: borderRadius.small,
      fontWeight: 500,
    },
    sizeSmall: {
      height: '24px',
    },
  },
  variants: [
    {
      props: { variant: 'soft' },
      style: ({ theme }) => ({
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.action.hover,
        border: `1px solid ${theme.palette.divider}`,
        '& .MuiChip-icon': { color: 'inherit' },
      }),
    },
    ...(
      ['primary', 'secondary', 'success', 'warning', 'error', 'info'] as const
    ).map((color) => ({
      props: { variant: 'soft' as const, color },
      style: ({ theme }: { theme: Theme }) => ({
        color: theme.palette[color].main,
        backgroundColor: alpha(theme.palette[color].main, 0.1),
        border: `1px solid ${alpha(theme.palette[color].main, 0.22)}`,
      }),
    })),
  ],
};
